export const customColumnKeys = {
	all: ['customColumns'],
	list: () => ['customColumns', 'list'],
};

export const customColumnMutationKeys = {
	create: ['customColumns', 'create'],
	update: ['customColumns', 'update'],
	delete: ['customColumns', 'delete'],
	preview: ['customColumns', 'preview'],
	fill: ['customColumns', 'fill'],
	setValue: ['customColumns', 'setValue'],
	exportList: ['customColumns', 'exportList'],
};
